import {callAPI, USER_TYPE} from "./api-service";
import {tokenService} from "./token.service";

export class partnerManagerService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  async getPartnersOfPartnerManager(date, minimum1 = false) {
    const token = await new tokenService().get(USER_TYPE.PARTNER_MANAGER);
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.PARTNER_MANAGER,
      endpoint: `partnermanager/partnersofpartnermanager/${token.email}/${date ? JSON.stringify(date) : null}/${minimum1}`,
      needsToken: true
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getAllPartnerManagers() {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "partnermanager/all",
      needsToken: true
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async createNewPartnerManager(data) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.ADMIN,
      endpoint: "partnermanager",
      needsToken: true,
      data: data
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getUsersOfPartnerManager(reqData) {
    const token = await new tokenService().get(USER_TYPE.PARTNER_MANAGER);
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.PARTNER_MANAGER,
      endpoint: `partnermanager/usersofpartnermanager/${token.email}/${JSON.stringify(reqData.dateRange)}/${reqData.skip}/${
        reqData.limit
      }/${JSON.stringify(reqData.filter)}/${JSON.stringify(reqData.minimum1)}`,
      needsToken: true
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getFormsOfPartnerManager(reqData) {
    const token = await new tokenService().get(USER_TYPE.PARTNER_MANAGER);
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.PARTNER_MANAGER,
      endpoint: `partnermanager/formsofpartnermanager/${token.email}/${JSON.stringify(reqData.dateRange)}`,
      needsToken: true
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async register(reqData) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.PARTNER_MANAGER,
      endpoint: "partnermanager/register",
      needsToken: false,
      data: reqData
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async activatePartnerManager(token) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.PARTNER_MANAGER,
      endpoint: "partnermanager/auth/activatePartnerManager",
      needsToken: false,
      data: {token: token}
    });
    return {
      success: result.status,
      message: "activated",
      token: result.data.token
    };
  }

  async changePartnerManagerOfPartner(reqData) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.ADMIN,
      endpoint: "partnermanager/changePartnermanagerOfPartner",
      needsToken: true,
      data: reqData
    });
    return {
      success: result.status,
      message: "updated"
    };
  }
}
